module.exports = __webpack_public_path__ + "static/img/01.9db1059.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/01.jpg
// module id = fZVH
// module chunks = 0